import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InlineButtonModule } from '@portal-core/ui/button/components/inline-button/inline-button.module';
import { PublicationAvatarComponent } from './publication-avatar.component';


@NgModule({
  declarations: [
    PublicationAvatarComponent
  ],
  imports: [
    CommonModule,
    InlineButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [
    PublicationAvatarComponent
  ]
})
export class PublicationAvatarModule { }
